<template>
  <div class="processqueue-container" id="processqueue-cont">
    <b-popover target="popover_processqueue" triggers="click blur" placement="topleft" container="processqueue-cont">
      <div class="process">
        <div class="process-panel">
          <div class="process-panel-header">
            <h2>Process Queue
              <a class="float-right" @click="$router.push({name:'Manage',params:{slug:'activityLog'}})" v-b-tooltip.hover title="View activity log">
                <out-arrow-icon class="icon-default outarrow show "></out-arrow-icon>
              </a>
            </h2>
          </div>
          <div class="process-panel-content">
            <div class="process-item" v-for="(process, index) in processHTML.activities" :key="index" v-bind:class="{active:showDetail[index]}">
              <div class="process-item-header" v-bind:class="process.status" v-b-toggle="'accordion-' + index">
                <h3>
                  {{process.title}}
                </h3>
                <div class="overflow-icon-container">
                  <b-dropdown variant="link" size="lg" no-caret>
                    <template slot="button-content">
                      <overflow-icon class="icon-default overflow show"></overflow-icon>
                    </template>
                    <b-dropdown-item @click="openReportIssue(process,$event)">Report Issue</b-dropdown-item>
                  </b-dropdown>
                </div>
                <div class="process-item-header-percentage-container" v-if="shouldShowProgress(process)">
                  <div class="process-item-header-percentage" v-if="process.percentageDone<100">
                    <span class="percentage" v-bind:style="{width:process.percentageDone+ '%'}"></span>
                  </div>

                  <b-progress v-else :max="100" class="process-item-header-percentage">
                    <b-progress-bar class="percentage" :value="100" striped :animated="true"></b-progress-bar>
                  </b-progress>

                  <div class="process-item-header-close-icon">
                    <b-btn variant="flat" class="p-0" @click="bulkKillTasks(process)">
                      <close-cirle-icon class="icon-default closecirlce show m-1"></close-cirle-icon>
                    </b-btn>
                  </div>
                </div>
                <div v-else class="process-item-header-date">
                  {{process.monthLabel}} @ {{process.timeLabel}}
                </div>
                <div class="process-item-status-details">
                  <span class="success-status-count">
                    <tick-simple-icon class="icon-default ticksimple" v-bind:class="{show:process.statusSummary.success}"></tick-simple-icon>
                    <span class="count">{{process.statusSummary.success}}</span>
                  </span>
                  <span class="error-status-count">
                    <alert-icon class="icon-default alerticon" v-bind:class="{show:process.statusSummary.error}"></alert-icon>
                    <span class="count">{{process.statusSummary.error}}</span>
                  </span>
                </div>
              </div>
              <b-collapse :id="'accordion-'+index" role="tabpanel" @show="setDetail(index,true)" @hide="setDetail(index,false)">
                <div class="process-item-content">
                  <div class="process-item-list" v-for="(history, historyID) in process.detailedStatus" :key="historyID">
                    <div class="w-100">
                      <h4>

                        {{history.siteName}}
                      </h4>
                    </div>
                    <div class="processdetail-label process-detail-item">
                      <div class="w-100" v-for="(additionalDetail,index) in history.additionalDetails" :key="index">

                        <div v-for="(detail,index) in additionalDetail.items" :key="index" v-bind:class="detail.status">
                          <div class="process-detail-item-title">
                            <tick-simple-icon class="icon-default ticksimple" v-bind:class="{'show' : detail.status==='success'}"></tick-simple-icon>
                            <alert-icon class="icon-default error" v-bind:class="{'show' : detail.status==='error'}"></alert-icon>
                            {{detail.title}}
                            <span class="process-detail-item-status loading float-right" v-bind:class="{hide:history.status==='success' || history.status==='error'}">
                              {{detail.mainStatus.trim()}}
                            </span>
                            <div class="overflow-icon-container" v-bind:class="detail.status">
                              <b-dropdown variant="link" size="lg" no-caret>
                                <template slot="button-content">
                                  <overflow-icon class="icon-default overflow show"></overflow-icon>
                                </template>
                                <b-dropdown-item @click="retryTask(history,$event)">Retry</b-dropdown-item>
                                <b-dropdown-item @click="openSiteReponse(history,$event)">View site response</b-dropdown-item>
                              </b-dropdown>
                            </div>
                          </div>

                          <div class="process-detail-item-message" v-if="detail.showErrorMsg" v-html="detail.errorMsg">
                          </div>

                        </div>
                        <div class="button-label" v-if="additionalDetail.label" v-bind:class="{show:history.status==='success' || history.status==='error'}">
                          {{additionalDetail.label}}
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </div>
        </div>
      </div>
    </b-popover>
    <!-- {{processHTML.showInProgress}} -->
    <b-btn class="process-trigger" id="popover_processqueue">
      <!-- <span class="processq-progress">

      </span> -->
      <span class="processq-progress">
        <h-progress-icon class="icon-default hprogress" v-bind:class="{ inprogress: processHTML.showInProgress || localProgress }"></h-progress-icon>
      </span>
      <span class="btn-label">
        Process Queue
      </span>
    </b-btn>
    <site-response ref="sitereponse" :history="currentHistory"></site-response>
    <report-issue ref="reportissue" :action="currentAction"></report-issue>
    <prompt-popup ref="promptpopup" :action="modalCallback" :args="modalArgs"></prompt-popup>
  </div>
</template>

<script>
import Vue from 'Vue';
import _ from 'lodash';
import Utils from '../mixins/utils';
import TickSimpleIcon from '../assets/ticksimple.svg';
import AlertIcon from '../assets/alert.svg';
import CloseCirleIcon from '../assets/closecircle.svg';
import CloseIcon from '../assets/close.svg';
import OutArrowIcon from '../assets/outarrow.svg';
import OverflowIcon from '../assets/overflow.svg';
import HProgressIcon from '../assets/hprogress.svg';

import SiteResponse from './modals/SiteResponse';
import ReportIssue from './modals/ReportIssue';
import PromptPopup from './modals/PromptPopup';

export default {
  name: 'processqueue',
  components: {
    TickSimpleIcon,
    AlertIcon,
    CloseCirleIcon,
    CloseIcon,
    OutArrowIcon,
    OverflowIcon,
    HProgressIcon,
    SiteResponse,
    ReportIssue,
    PromptPopup
  },
  mixins: [Utils],
  data() {
    return {
      localProgress: false,
      showProgressPanel: false,
      showDetail: {},
      sitesData: {},
      currentHistory: {},
      currentAction: {},
      modalCallback: {},
      modalArgs: {},
      historyRefreshInterval: null,
      forcedAjaxInterval: 1
    };
  },
  computed: {
    processHTML() {
      return this.$store.getters.getPanelHistory;
    },
    sites() {
      return this.$store.getters.getSites;
    }
  },
  created() {
    window.eventHub.$on('refreshHistoryImmediately', event => {
      this.forcedAjaxInterval = event.forcedAjaxInterval;
      clearInterval(this.historyRefreshInterval);
      this.initRefreshInterval(this.forcedAjaxInterval * 1000);
    });

    window.eventHub.$on('refreshHistory', event => {
      let sendNextAjaxCallAfter = event.sendNextAjaxCallAfter;
      this.forcedAjaxInterval = event.forcedAjaxInterval;
      this.coolDownRefreshTimer(sendNextAjaxCallAfter);
    });
    window.eventHub.$on('clearRefreshHistory', event => {
      clearInterval(this.historyRefreshInterval);
    });
  },
  methods: {
    toggelProgressPanel() {
      if (this.showProgressPanel) {
        this.showProgressPanel = false;
      } else {
        this.showProgressPanel = true;
      }
    },
    setDetail(index, value) {
      Vue.set(this.showDetail, index, value);
      Vue.nextTick().then(() => {
        this.$forceUpdate();
      });
    },
    openSiteReponse(history) {
      this.currentHistory = history;
      this.$root.$emit('bv::hide::popover');
      this.$refs.sitereponse.$refs.siteresponsemodal.show();
    },
    doReportIssue(action) {
      this.currentAction = action;

      this.$refs.reportissue.$refs.reportissuemodal.show();
    },
    shouldShowProgress(process) {
      let status = process.status;
      if (status == 'success' || status == 'error' || status == 'partial') {
        return false;
      }
      return true;
    },
    openReportIssue(action, $event) {
      this.$refs.promptpopup.$refs.promptmodal.show();
      this.modalCallback = this.doReportIssue;
      this.modalArgs = action;
      this.$root.$emit('bv::hide::popover');
      if ($event) {
        $event.stopPropagation();
        $event.preventDefault();
      }
    },
    doRetryTask(history) {
      let payload = {
        requiredData: {
          manualRetryFailedTask: history.historyID
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
      });
    },
    retryTask(history) {
      this.$root.$emit('bv::hide::popover');
      this.modalCallback = this.doRetryTask;
      this.modalArgs = history;
      this.$refs.promptpopup.$refs.promptmodal.show();
    },
    doBulkillTasks(action) {
      let payload = {
        requiredData: {
          terminatePendingProcess: {
            actionID: action.actionID
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
      });
    },
    bulkKillTasks(action) {
      this.$root.$emit('bv::hide::popover');
      this.modalCallback = this.doBulkillTasks;
      this.modalArgs = action;
      this.$refs.promptpopup.$refs.promptmodal.show();
    },
    doKillTasks(history) {
      let payload = {
        requiredData: {
          terminatePendingProcess: {
            historyID: history.historyID
          }
        }
      };
      this.$store.dispatch('sendAction', payload).then(response => {
        
      });
    },
    killTasks(history) {
      this.modalCallback = this.doKillTasks;
      this.modalArgs = history;
      this.$refs.promptpopup.$refs.promptmodal.show();
    },
    initRefreshInterval(intervalInMs) {
      this.historyRefreshInterval = setInterval(() => {
        this.localProgress = true;
        this.$store
          .dispatch({
            type: 'getPanelHistory'
          })
          .then(response => {
            this.localProgress = false;
            let getWaitData = response.data.getWaitData;
            if (getWaitData) {
              
              this.processGetWaitData(getWaitData);
            } else {
              let currentReloadActionID = this.$store.getters.getStateVariable(
                'currentReloadActionID'
              );
              if (currentReloadActionID) {
                this.$store.commit('SET_STATE_VARIABLE', {
                  variable: 'currentReloadProgress',
                  value: {
                    total: 0,
                    loaded: 0
                  }
                });
              }
            }
          })
          .catch(err => {
            
          });
      }, intervalInMs);
    },
    processGetWaitData(getWaitData) {
      let currentReloadActionID = this.$store.getters.getStateVariable(
        'currentReloadActionID'
      );
      _.forEach(getWaitData, (action, actionId) => {
        let actionData = getWaitData[actionId].data;
        if (currentReloadActionID && currentReloadActionID == actionId) {
          this.$store.commit('SET_STATE_VARIABLE', {
            variable: 'currentReloadProgress',
            value: {
              total: getWaitData[actionId].total,
              loaded: getWaitData[actionId].loaded
            }
          });
        } else if (
          currentReloadActionID &&
          typeof getWaitData[actionId] == 'undefined'
        ) {
          this.$store.commit('SET_STATE_VARIABLE', {
            variable: 'currentReloadProgress',
            value: {
              total: 0,
              loaded: 0
            }
          });
        }
        if (actionData) {
          _.forEach(actionData, (actionDataItem, actionDataKey) => {
            let mutationKey = this.getMutationBasedOnKey(actionDataKey);
            if (mutationKey) {
              this.$store.commit(mutationKey, actionDataItem);
            }
          });
        }
      });
    },
    coolDownRefreshTimer(sendNextAjaxCallAfter) {
      if (
        typeof sendNextAjaxCallAfter != 'undefined' &&
        sendNextAjaxCallAfter != null
      ) {
        if (sendNextAjaxCallAfter != 0) {
          let tempTimeOut;
          if (typeof this.forcedAjaxInterval != 'undefined') {
            if (this.forcedAjaxInterval <= sendNextAjaxCallAfter) {
              tempTimeOut = sendNextAjaxCallAfter * 1000;
            } else {
              tempTimeOut = this.forcedAjaxInterval * 1000;
            }
          } else {
            tempTimeOut = sendNextAjaxCallAfter * 1000;
          }

          clearInterval(this.historyRefreshInterval);
          this.initRefreshInterval(tempTimeOut);
        } else {
          let tempForcedAjaxTimeOut = 5 * 1000;
          if (typeof this.forcedAjaxInterval != 'undefined') {
            if (this.forcedAjaxInterval < 5) {
              tempForcedAjaxTimeOut = 5 * 1000;
            } else {
              tempForcedAjaxTimeOut = this.forcedAjaxInterval * 1000;
            }
          }
          clearInterval(this.historyRefreshInterval);
          this.initRefreshInterval(tempForcedAjaxTimeOut);
        }
      }
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ProcessQueue.vue